import React, { createContext, useState, useEffect } from "react";
import { getCachedSettings } from "../utils/appConfigCache";

const SiteNameContext = createContext();

const getTenantStorageKey = (key) => {
  const tenantSlug = localStorage.getItem("tenant_slug") || "default";
  return `${key}:${tenantSlug}`;
};

const getSiteNameStorageKey = () => {
  return getTenantStorageKey("site_name");
};

const getStoredSiteName = () => {
  const tenantScoped = localStorage.getItem(getSiteNameStorageKey());
  const legacy = localStorage.getItem("site_name");
  return (tenantScoped || legacy || "").trim();
};

export function SiteNameProvider({ children }) {
  const [siteName, setSiteName] = useState(() => getStoredSiteName() || "Alumni Connect");

  useEffect(() => {
    getCachedSettings()
      .then((settings) => {
        const fromApi = (settings?.site_name || "").trim();
        const languageOptions = settings?.language_options;

        if (fromApi) {
          const storageKey = getSiteNameStorageKey();
          setSiteName(fromApi);
          localStorage.setItem(storageKey, fromApi);
          localStorage.setItem("site_name", fromApi);
        }

        if (Array.isArray(languageOptions) && languageOptions.length) {
          const languageCodes = languageOptions.map((option) => option.code);
          localStorage.setItem(getTenantStorageKey("enabled_language_options"), JSON.stringify(languageOptions));
          localStorage.setItem(getTenantStorageKey("enabled_languages"), JSON.stringify(languageCodes));
          localStorage.setItem("enabled_language_options", JSON.stringify(languageOptions));
          localStorage.setItem("enabled_languages", JSON.stringify(languageCodes));

          const currentLanguage = localStorage.getItem(getTenantStorageKey("app_language"))
            || localStorage.getItem("app_language")
            || "en";
          if (!languageCodes.includes(currentLanguage)) {
            const fallback = languageCodes[0];
            localStorage.setItem(getTenantStorageKey("app_language"), fallback);
            localStorage.setItem("app_language", fallback);
            window.dispatchEvent(new Event("app-language-change"));
          }

          window.dispatchEvent(new Event("app-language-options-change"));
        }
      })
      .catch(() => {
        // keep local storage/default value
      });
  }, []);

  const updateSiteName = (newName) => {
    setSiteName(newName);
    localStorage.setItem(getSiteNameStorageKey(), newName);
    localStorage.setItem("site_name", newName);
  };

  const value = {
    siteName,
    updateSiteName,
  };

  return (
    <SiteNameContext.Provider value={value}>
      {children}
    </SiteNameContext.Provider>
  );
}

export default SiteNameContext;
